const NIVELES = {
    TOTAL:      { label: "Cubierto 100%",    cls: "badge-cobertura--total" },
    PARCIAL:    { label: "Cobertura parcial", cls: "badge-cobertura--parcial" },
    NO_CUBIERTA:{ label: "Sin cobertura",    cls: "badge-cobertura--ninguna" },
};

export function BadgeCobertura({ nivel }) {
    const info = NIVELES[nivel] ?? NIVELES.NO_CUBIERTA;
    return <span className={`badge-cobertura ${info.cls}`}>{info.label}</span>;
}